import React from 'react';
import styles from '../Navbar.module.css';

const MarketingIkonica = (props) => (
   <svg  className={styles.sadrzajMainDugmeIkonicaPopravak7} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_3719_17243)">
<path fillRule="evenodd" clipRule="evenodd" d="M17.0625 20.4062H19.4062V9.46875H17.0625V20.4062ZM26.4375 4.78125L20.9688 8.42734V21.4477L26.4375 25.0938C27.3 25.0938 28 24.3937 28 23.5312V6.34375C28 5.48125 27.3 4.78125 26.4375 4.78125ZM3 14.9375C3 17.8539 5.00078 19.7406 7.70234 20.2578L7.6875 20.4062V26.6562C7.6875 27.5187 8.3875 28.2188 9.25 28.2188H11.5938C12.4563 28.2188 13.1562 27.5187 13.1562 26.6562V20.4062H15.5V9.46875H9.25C5.79844 9.46875 3 11.4859 3 14.9375Z" fill="#1070D1"/>
</g>
<defs>
<clipPath id="clip0_3719_17243">
<rect width="25" height="25" fill="white" transform="translate(3 4)"/>
</clipPath>
</defs>
</svg>
);

export default MarketingIkonica;